<template>
    <form @submit.prevent="submit">
        <div class="grid grid-cols-5 gap-x-3">
            <FieldWithLabel
                class="col-span-2"
                label="區號"
                placeholder="電話區號"
                v-model="form['country_code']"
                type="select"
                :disabled="disabled"
                :options="countryCodeOptions"
            />
            <FieldWithLabel
                id="tel"
                class="col-span-3"
                v-model="form['identity']"
                label="電話號碼"
                placeholder="電話號碼"
                :disabled="disabled"
            />
        </div>

        <FieldWithLabel
            id="password"
            type="password"
            v-model="form['password']"
            label="密碼"
            placeholder="密碼"
            :disabled="disabled"
        />

        <button type="submit" class="btn mb-5 h-12 w-full text-base" :disabled="disabled">
            登入
        </button>

        <ul class="space-y-3 text-center text-sm">
            <li>
                <nuxt-link
                    :to="localePath('/teams/policies/privacy')"
                    class="text-gray-500"
                    >隱私政策</nuxt-link
                >
            </li>
            <li>
                <nuxt-link
                    :to="localePath('/auth/register')"
                    class="font-bold text-primary"
                    >沒有帳號？立即註冊</nuxt-link
                >
            </li>
            <li>
                <nuxt-link
                    :to="localePath('/auth/forgot')"
                    class="text-primary font-bold"
                    >忘記密碼？</nuxt-link
                >
            </li>
        </ul>
    </form>
</template>

<script>
export default {
    props: {
        disabled: Boolean,
    },
    data() {
        return {
            form: {
                country_code: this.defaultCountryCode,
            },
        };
    },
    methods: {
        submit() {
            this.$emit("submit", this.form);
        },
    },
};
</script>

<style lang="scss" scoped></style>
